<template>
  <print v-if="isPrint" :board="board" :form="form" />
  <div v-else>
    <!--    기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      field-name="회사명(필수)"
      :options="[
        { type: 'text', label: '점검자', value: '점검자' },
        { type: 'date', label: '점검일(필수)', value: '점검일' },
        { type: 'text', label: '점검장소' },
        { type: 'alert', label: '알림 대상자 선택' },
      ]"
      :board="this.board"
      :is-print="isPrint"
    />

    <TableInspectMerge
      :is-print="isPrint"
      :is-readonly="board.readonly"
      :title="$t('예방 점검표')"
      contentBefore="•"
      v-model="form.inspectList"
      class="mt-28px"
    />

    <!--    파일첨부-->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import TableCustom from "@/components/TableCustom.vue";
import TableInspectMerge from "@/components/TableInspectMerge";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";
import FileUploadModule from "@/views/modules/FileUploadModule";
import { required } from "vuelidate/lib/validators";
import Print from "./Print.vue";

export default {
  components: {
    Print,
    PhotoUploadGridModule,
    FieldSelectModule,
    FileUploadModule,
    TableCustom,
    TableInspectMerge,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  validations: {
    form: {
      stdInfo: {
        field_name: { required },
        점검자: { required },
        점검일: { required },
      },
    },
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      inspectionTitle: "안전·보건 합동점검표",
      form: {
        stdInfo: {},

        fileList: [],
        inspectList: [
          {
            content: "<span class='font-normal'>덮개 등 방호장치를 설치하고 그 장치가 정상적으로 작동하고 있는지</span>\n" +
              "<span class='font-normal' style='color:#6C6C6C'>(안전보건기준에 관한 규칙 제87조)</span>",
            isChecked: "",
            title: "방호덮개, 안전가드 등 방호장치",
          },
          {
            content: "<span class='font-normal'>방호장치가 정상적으로 작동하고 있는지</span>\n" +
              "<span class='font-normal' style='color:#6C6C6C'>(안전보건기준에 관한 규칙 제93조)</span>",
            isChecked: "",
            title: "방호덮개, 안전가드 등 방호장치",
          },
          {
            content: "<span class='font-normal'>비상정지장치를 설치하고 그 장치가 정상적으로 작동하고 있는지</span>\n" +
              "<span class='font-normal' style='color:#6C6C6C'>(안전보건기준에 관한 규칙 제88조, 제192조)</span>",
            isChecked: "",
            title: "비상정지장치",
          },
          {
            content: "<span class='font-normal'>점검, 수리 등의 정비 작업 시 전원을 차단하였는지</span>\n" +
              "<span class='font-normal' style='color:#6C6C6C'>(안전보건기준에 관한 규칙 제92조)</span>",
            isChecked: "",
            title: "전원차단",
          },
          {
            content: "<span class='font-normal'>정지한 기계를 임의로 운전하는 것을 방지하기 위한 잠금장치 또는 표지판을 설치하였는지</span>\n" +
              "<span class='font-normal' style='color:#6C6C6C'>(안전보건기준에 관한 규칙 제92조)</span>",
            isChecked: "",
            title: "전원차단",
          },
          {
            content: "<span class='font-normal'>안전인증 및 안전검사를 적정하게 받고 사용하는지</span>\n" +
              "<span class='font-normal' style='color:#6C6C6C'>(산업안전보건법 제84조, 제93조)</span>",
            isChecked: "",
            title: "안전인증 안전검사",
          },
        ],
      },
    };
  },
  methods: {
    validate() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        if (!this.$v.form.stdInfo.field_name.required) return "회사명을 반드시 입력해야 합니다";
        else if (!this.$v.form.stdInfo["점검자"].required) return "점검자를 반드시 입력해야 합니다";
        else if (!this.$v.form.stdInfo["점검일"].required) return "점검일을 반드시 입력해야 합니다";
      }
    },
  },
};
</script>
